module.exports = __webpack_public_path__ + "img/commande.dffb0b61.png";